import { Text } from "preact-i18n";

import { Modal } from "@revoltchat/ui";

import { noopTrue } from "../../../lib/js";

import { ModalProps } from "../types";

export default function FileEmpty({
    filename,
    ...props
}: ModalProps<"file_empty">) {
    return (
        <Modal
            {...props}
            title={<Text id="app.special.modals.error" />}
            actions={[
                {
                    onClick: noopTrue,
                    confirmation: true,
                    children: <Text id="app.special.modals.actions.ok" />,
                },
            ]}>
            <Text
                id="error.FileEmpty"
                fields={{
                    filename,
                }}
            />
        </Modal>
    );
}
